import { GitBranch } from 'lucide-react';

import { NodeShell } from './NodeShell';

interface ConditionRule {
  field: string;
  operator?: string;
  value?: string;
}

interface ConditionNodeData {
  label: string;
  field?: string;
  operator?: string;
  value?: string;
  logic?: 'AND' | 'OR';
  rules?: ConditionRule[];
}

export const ConditionNode = ({
  data,
  selected,
}: {
  data: ConditionNodeData;
  selected?: boolean;
}) => {
  // Compound condition (rules[]) — the panel edits rules[i] directly, so
  // data.field is a stale single-rule remnant. Summarise rules instead.
  const rules = data.rules ?? [];
  const isCompound = rules.length > 0;

  const subtitle = isCompound
    ? `${rules.length} rule${rules.length === 1 ? '' : 's'} (${data.logic ?? 'AND'}) · ${rules[0].field}${
        rules.length > 1 ? ` +${rules.length - 1}` : ''
      }`
    : data.field
      ? `${data.field} ${data.operator ?? ''} ${data.value ?? ''}`.trim()
      : undefined;

  return (
    <NodeShell
      type="condition"
      icon={<GitBranch size={16} />}
      label={data.label}
      subtitle={subtitle}
      selected={selected}
      sources={[
        {
          id: 'true',
          top: '32%',
          handleClass: '!bg-green-500',
          label: 'true',
          labelClass: 'text-green-600',
        },
        {
          id: 'false',
          top: '68%',
          handleClass: '!bg-red-500',
          label: 'false',
          labelClass: 'text-red-600',
        },
      ]}
    />
  );
};
